/* v8 ignore start */
"use client";

import {Provider} from "react-redux";

import ErrorBoundary from "@/components/providers/errorBoundary";
import ScreenInitializer from "@/components/providers/screenInitializer";
import TokenReceiver from "@/components/providers/tokenReceiver";
import {RollbarClient} from "@/lib/utils/rollbar.client";
import {store} from "@/store";

interface IProps {
  children: React.ReactNode;
}

export function Providers(props: IProps) {
  const {children} = props;

  return (
    <ErrorBoundary onError={RollbarClient.error}>
      <Provider store={store}>
        {children}
        <TokenReceiver />
        <ScreenInitializer />
      </Provider>
    </ErrorBoundary>
  );
}
/* v8 ignore stop */
